module.exports = __webpack_public_path__ + "img/41.1.71a9aaf9.jpg";